import { useContent } from './useContent';
import {
  CONTENT_KEYS,
  PAGE_VISIBILITY_DEFAULT,
  PageVisibilityContent,
} from '../content/schema';

export interface UsePageVisibilityResult {
  visibility: PageVisibilityContent;
  isVisible: (key: keyof PageVisibilityContent) => boolean;
}

/**
 * Reads the page-visibility CMS key and exposes a typed helper.
 * Falls back to PAGE_VISIBILITY_DEFAULT (all pages on, aboutTeam off).
 */
export function usePageVisibility(): UsePageVisibilityResult {
  const { data: visibility } = useContent<PageVisibilityContent>(
    CONTENT_KEYS.pageVisibility,
    PAGE_VISIBILITY_DEFAULT
  );

  const isVisible = (key: keyof PageVisibilityContent): boolean => {
    const val = visibility[key];
    // Treat undefined as true so newly added keys don't break existing pages
    return val === undefined ? true : val;
  };

  return { visibility, isVisible };
}
